import { RolesTable } from '../components/RolesTable';

export const RolesPage = () => {
  return <RolesTable />;
};
